import React, { useState, useEffect } from 'react';
import Splash from '../../../../splash/Splash';

function APIS({ setGlobalData, refreshPvtData }) {
    const isLoggedIn = !!localStorage.getItem('token');
    const [isLoadingPublic, setIsLoadingPublic] = useState(true);
    const [, setIsLoadingPrivate] = useState(isLoggedIn);

    const [, setError] = useState(null);

    // Define API data states
    const [apiData, setApiData] = useState({
        sliders: { main: [], favourite: [], feature: [] },
        socialLinks: [],
        general: {},
		paymentMethods: [],
		withdrawMethods: [],
		hasEWallet: false,
        promotions: { activePromotion: [], displayPromotion: [], allPromotions: [] },
        userData: null,
        transactions: [], 
        turnovers: [], 
        marketBlock: [],
    });

    // Fetch Public APIs (No login required)
    useEffect(() => {
        const fetchPublicData = async () => {
            setIsLoadingPublic(true);

            try {
				let headers = {};
				const token = localStorage.getItem('token');
				let hasEWallet = false;
				if (token) { 
					headers = { Authorization: `Bearer ${token}` };
				}

                const apiResponses = await Promise.all([
                    fetch(`${process.env.REACT_APP_API_URL}/api/sliders`, { headers: headers }).then(res => res.json()),
                    fetch(`${process.env.REACT_APP_API_URL}/api/sociallink`, { headers: headers }).then(res => res.json()),
                    fetch(`${process.env.REACT_APP_API_URL}/api/general`, { headers: headers }).then(res => res.json()),
                    fetch(`${process.env.REACT_APP_API_URL}/api/payment-methods`, { headers: headers }).then(res => res.json()),
					fetch(`${process.env.REACT_APP_API_URL}/api/promotion`, { headers: headers }).then(res => res.json()),
                ]);

                const [slidersData, socialData, generalData, paymentData, promotionsData] = apiResponses;
				let pgs = [];
				
				
				if (paymentData?.type === 'ewallet') {
					pgs = paymentData?.pgs
					hasEWallet = true;
				} else {
					pgs = paymentData;
					hasEWallet = false;
				}

                setApiData(prevData => ({
					...prevData,
					hasEWallet: hasEWallet,
                    sliders: {
                        main: slidersData.filter(slider => slider.status === 'active' && slider.slider_type === 'Main'),
                        favourite: slidersData.filter(slider => slider.status === 'active' && slider.slider_type === 'Favourite'),
                        feature: slidersData.filter(slider => slider.status === 'active' && slider.slider_type === 'Features'),
                    },
                    socialLinks: socialData[0] || {},
                    general: generalData[0] || {},
                    paymentMethods: pgs, 
                    promotions: {
                        activePromotion: promotionsData.filter(promo => promo.status === 'active'),
                        displayPromotion: promotionsData.filter(promo => promo.status === 'display'),
                        allPromotions: promotionsData,
                    },
                }));

            } catch (error) {
                console.error('Error fetching public data:', error);
                setError('Error fetching public API data');
            } finally {
                setIsLoadingPublic(false);
            }
        };

        fetchPublicData();
    }, []);

    // Fetch Private APIs (Login required)
    useEffect(() => {
        const token = localStorage.getItem('token');
        const remoteId = localStorage.getItem('remote_id');

        if (isLoggedIn && token && remoteId) {
            setIsLoadingPrivate(true);

            const fetchPrivateData = async () => {
                try {

                    const apiResponses = await Promise.all([
                        fetch(`${process.env.REACT_APP_API_URL}/api/user/show?remote_id=${remoteId}`, {
                            method: 'GET',
                            headers: { Authorization: `Bearer ${token}` },
                        }).then(res => res.json()),
                        fetch(`${process.env.REACT_APP_API_URL}/api/transaction/show?remote_id=${remoteId}`, {
                            method: 'GET',
                            headers: { Authorization: `Bearer ${token}` },
                        }).then(res => res.json()),
                        fetch(`${process.env.REACT_APP_API_URL}/api/turnovers?remote_id=${remoteId}`, {
                            method: 'GET',
                            headers: { Authorization: `Bearer ${token}` },
                        }).then(res => res.json()),
                        fetch(`${process.env.REACT_APP_API_URL}/api/market/block`, {
                            method: 'GET',
                            headers: { Authorization: `Bearer ${token}` },
                        }).then(res => res.json()),
                    ]);

                    

                    const [userData, transactions, turnovers, marketBlock] = apiResponses;

                    setApiData(prevData => ({
                        ...prevData,
                        userData,
                        transactions,
                        turnovers: turnovers.turnover || [],
                        marketBlock: marketBlock || [],
                    }));

                } catch (error) {
                    console.error('Error fetching private data:', error);
                    setError('Error fetching user data');
                } finally {
                    setIsLoadingPrivate(false);
                }
            };

            fetchPrivateData();
        }
    }, [isLoggedIn, refreshPvtData]);

    // Pass API data to global state in App.js
    useEffect(() => {
        setGlobalData(apiData);
    }, [apiData, setGlobalData]);

    // **Loading State Handling**
    if (isLoadingPublic) {
        return (
          <Splash/>
        );
    }

    return null;
}

export default APIS;
